module.exports = __webpack_public_path__ + "img/126.d0a291ad.jpg";